<script>
    import { createEventDispatcher } from 'svelte';
    import { memberInfo, appSetting, checkFeature, appVer, resolveIcpPayType, compareSemver } from '../store/inapp-store'
    import { Modal } from '../components';

    const dispatch = createEventDispatcher();

    export let selectedPayType
    export let selectedRefundType
    let showRefundTypeSelector = false

    let enableCashPay = checkFeature($appSetting.enableCashPay, $memberInfo.gid, $appSetting.guestList)
    let enableBUReturn = checkFeature($appSetting.enableBUReturn, $memberInfo.gid, $appSetting.guestList)
    let enablePurseRefund = checkFeature($appSetting.enablePurseRefund, $memberInfo.gid, $appSetting.guestList)
    let enableOnlinePay = !handlePausePeriod()
    selectedPayType = enableOnlinePay ? selectedPayType : 'offline'
    showRefundTypeSelector = enableOnlinePay ? showRefundTypeSelector : true

    // 金流服務暫停顯示判斷，若為白名單則不顯示暫停訊息
    if(!enableOnlinePay) {
        let matchGID = Array.isArray($appSetting.guestList) ? $appSetting.guestList.find(el=> el === $memberInfo.gid) : undefined
        enableOnlinePay = matchGID !== undefined
    }

    // 金流服務暫停訊息popup
    let modal = { title : $appSetting.onlinepayPauseConfig?.messages?.[0] ?? '', message : $appSetting.onlinepayPauseConfig?.messages?.[1] ?? '', type: 'alert' }
    let isOpen = !enableOnlinePay

    // 版本更新提示訊息
    let modalVersionUpdate = { title : '登記借杯', message : '請更新至最新版本以繼續使用線上支付功能', type: 'alert' }
    let isOpenVersionUpdate = false

    $: icpPayType = resolveIcpPayType($appVer)
    $: newopwPaused = !enableOnlinePay && ($appSetting.onlinepayPauseConfig?.payTypes?.includes('newopw') ?? false)
    $: icpoPaused = !enableOnlinePay && ($appSetting.onlinepayPauseConfig?.payTypes?.includes(icpPayType) ?? false)

    /**
     * 選擇結帳方式後觸發此方法
     * @param payType
     */
    function changePayType (payType) {
        const resolvedPayType = payType === 'icpo' ? icpPayType : payType

        // 金流服務暫停顯示判斷 （舊版）
        if(!enableOnlinePay && resolvedPayType === 'online') {
            isOpen = true
            return false
        }

        // 金流服務暫停顯示判斷 （新版）
        if(isOnlinePaymentPausePeriod(resolvedPayType)) {
            isOpen = true
            return false
        }

        // 根據版本檢查支付方式是否可用
        // NEWOPW 需要 >= 5.66，ICPO 需要 >= 5.64
        if (resolvedPayType === 'newopw' && compareSemver($appVer, '5.66.0') < 0) {
            isOpenVersionUpdate = true
            return false
        }

        if ((resolvedPayType === 'icpo' || resolvedPayType === 'icpo_a2a') && compareSemver($appVer, '5.64.0') < 0) {
            isOpenVersionUpdate = true
            return false
        }

        // 選擇結帳方式
        selectedPayType = resolvedPayType
        showRefundTypeSelector = selectedPayType === 'offline'
        console.log('### selectedPayType', selectedPayType)

        // 觸發結帳方式更新
        dispatch('updatePayType', selectedPayType);
    }

    /**
     * 選擇到店支付退款方式後觸發此方法
     * @param refundType
     */
     function changeRefundType  (refundType) {
        selectedRefundType = refundType
        console.log('###### selectedRefundType', selectedRefundType)
        dispatch('updateRefundType', selectedRefundType);
    }

    /**
     * 判斷目前是否處於金流服務暫停期間
     */
    function handlePausePeriod() {
        const { beginTime, endTime } = $appSetting.onlinepayPauseConfig;
        const inPause = new Date(beginTime) < new Date() && new Date(endTime) > new Date()
        return inPause
    }

    /**
     * 判斷目前是否處於金流服務暫停期間(新線上支付)
     */
    function isOnlinePaymentPausePeriod(payType) {
        return handlePausePeriod() && $appSetting.onlinepayPauseConfig.payTypes.includes(payType) && !enableOnlinePay
    }

    /**
     * 當用戶關閉popup時,觸發此方法
     */
    function onCloseModal() {
        isOpen = false
        isOpenVersionUpdate = false
        selectedPayType = 'offline'
        return false
    }

</script>

<div class="pay">
    <p class="pay-p">請選擇結帳方式</p>
</div>

<div class="payment">

<!-- 新錢包選項 -->
<div class="pay-wrap" style:opacity={newopwPaused ? 0.4 : 1} style:pointer-events={newopwPaused ? 'none' : 'auto'}>
    <label for="a" class="pay-label" on:click={()=> changePayType('newopw')}>
        <input name="payment" type="radio" id="a" class="a-in" bind:group={selectedPayType} value="newopw">
        <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
    </label>
    <img src="img/ic-pay-online.svg" alt="">
    <p>線上支付 <img src="img/payment-open-point.png" alt="" style="height: 1.2em; width: auto; vertical-align: middle;"></p>
</div>

<!-- ICPO 選項 -->
<div class="pay-wrap" style:opacity={icpoPaused ? 0.4 : 1} style:pointer-events={icpoPaused ? 'none' : 'auto'}>
    <label for="a" class="pay-label" on:click={()=> changePayType('icpo')}>
        <input name="payment" type="radio" id="a" class="a-in" bind:group={selectedPayType} value={icpPayType}>
        <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
    </label>
    <img src="img/ic-pay-online.svg" alt="">
    <p>線上支付 <img src="img/payment-icpo.png" alt="" style="height: 1.2em; width: auto; vertical-align: middle;"></p>
</div>

{#if (enableCashPay)}
    <div class="pay-wrap">
        <label for="b" class="pay-label" on:click={()=> changePayType('offline')}>
            <input name="payment" type="radio" id="b" class="a-in" bind:group={selectedPayType} value="offline">
            <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
        </label>
        <img src="img/ic-pay-store.svg" alt="">
        <p>到店支付 {enableBUReturn ? '（僅限統一超商）' : ''}</p>
    </div>
{/if}
</div>

{#if enableBUReturn && showRefundTypeSelector}
    {#if enablePurseRefund}
    <div class="payment">
        <div class="pay-wrap">
            <label for="a" class="pay-label" on:click={()=> changeRefundType('purse')}>
                <input name="refundType" type="radio" id="a" class="a-in" bind:group={selectedRefundType} value="purse">
                <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
            </label>
            <p>&nbsp;同意使用零錢包接受退款</p>
        </div>
        <div class="pay-wrap pt-2">
            <label for="b" class="pay-label" on:click={()=> changeRefundType('pos')}>
                <input name="refundType" type="radio" id="b" class="a-in" bind:group={selectedRefundType} value="pos">
                <span class="a-sn"><img src="img/atom-button-control-radio-button-btn-radio-t.svg" alt=""></span>
            </label>
            <p>&nbsp;至門市櫃台退現金</p>
        </div>
    </div>
    {:else}
    <div class="srvmk text-center">
        <p class="srvmk-ctn" style="color: #fd4c01">
            還杯後至7-ELEVEn櫃台退款
        </p>
    </div>
    {/if}
{/if}

<Modal {modal} {isOpen} on:closeModal={onCloseModal}></Modal>
<Modal modal={modalVersionUpdate} isOpen={isOpenVersionUpdate} on:closeModal={onCloseModal}></Modal>
